import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de concentration molaire";
const DESCRIPTION =
  "Calculatrice de concentration molaire. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "dilution calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/dilution-calculator/";
function DilutionCalculator() {
  const [initialMolarity, setInitialMolarity] = useState("");
  const [initialVolume, setInitialVolume] = useState("");
  const [finalVolume, setFinalVolume] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!initialMolarity || !initialVolume || !finalVolume) {
        setError("Veuillez entrer tous les paramètres");
        setResult(null);
        return;
      }
      const m1 = parseFloat(initialMolarity);
      const v1 = parseFloat(initialVolume);
      const v2 = parseFloat(finalVolume);
      if (m1 < 0 || v1 <= 0 || v2 <= 0) {
        setError("Les valeurs doivent être positives");
        setResult(null);
        return;
      }
      if (v2 < v1) {
        setError("Volume final doit être > volume initial");
        setResult(null);
        return;
      }
      const m2 = (m1 * v1) / v2;
      const volumeWater = (v2 - v1).toFixed(2);
      setResult({
        finalMolarity: m2.toFixed(4),
        volumeWater: volumeWater
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de dilution calcule la concentration molaire finale
                  après dilution d'une solution chimique. Formule: M1V1 = M2V2.
                </p>
                <ul>
                  <li>Calculs de dilution chimique</li>
                  <li>Basé sur la formule classique</li>
                  <li>Utile pour la chimie de laboratoire</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Molarité initiale (M)
                      </label>
                      <input
                        type="number"
                        value={initialMolarity}
                        onChange={(e) => setInitialMolarity(e.target.value)}
                        placeholder="M1"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Volume initial (mL)
                      </label>
                      <input
                        type="number"
                        value={initialVolume}
                        onChange={(e) => setInitialVolume(e.target.value)}
                        placeholder="V1"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Volume final (mL)
                      </label>
                      <input
                        type="number"
                        value={finalVolume}
                        onChange={(e) => setFinalVolume(e.target.value)}
                        placeholder="V2"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Molarité finale: <strong>{result.finalMolarity} M</strong></p>
                      <p>Eau à ajouter: <strong>{result.volumeWater} mL</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Principe de la dilution</h3></div>
              <div className="info-section-body">
                <p>Lors d'une dilution, la quantite de solute reste constante, mais le volume total augmente. C'est pourquoi la concentration diminue selon la relation M1V1 = M2V2.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment utiliser ce calcul</h3></div>
              <div className="info-section-body">
                <p>Entrez la concentration initiale, le volume initial puis le volume final vise. La calculatrice retourne la concentration finale ainsi que le volume d'eau a ajouter pour atteindre cette dilution.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Bonnes pratiques en TP</h3></div>
              <div className="info-section-body">
                <p>Utilisez des verreries adaptees (pipette, fiole jaugee) et notez toutes les unites en mL ou L de facon coherente. Un volume final mal mesure entraine un ecart direct sur la concentration obtenue.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DilutionCalculator;
